module.exports = __webpack_public_path__ + "img/chevron_down.6d78ec77.svg";